import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-esg-documents-dialog',
    templateUrl: './esg-documents-dialog.component.html',
    styleUrls: ['./esg-documents-dialog.component.scss'],
})
export class EsgDocumentsDialogComponent implements OnInit {
    @Input() visible: any;

    constructor() {}
    @Output() visibleChange = new EventEmitter<boolean>(); // Emits changes

    closeDialog() {
        this.visibleChange.emit(false); // Notify parent that dialog is closed
    }

    ngOnInit(): void {}
}
